export enum SliderGradient {
    GRADIENT1 = "Gradient1",
    GRADIENT2 = "Gradient2"
}


export interface SliderLegend {
    low: string;
    high: string;
}


export interface SliderInfo {
    legend: SliderLegend;
    gradient: SliderGradient;
}